import { render } from "./BalanceInfo.vue?vue&type=template&id=90897ef8&scoped=true"
import script from "./BalanceInfo.vue?vue&type=script&lang=js"
export * from "./BalanceInfo.vue?vue&type=script&lang=js"

import "./BalanceInfo.vue?vue&type=style&index=0&id=90897ef8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90897ef8"]])

export default __exports__